/**
 * Created by dreamc_t on 2017/5/2.
 */
import './notice.scss';
import tmpl from './notice.ejs'

class Notice {
    constructor(info, native, liveid) {
        this.info = info;
        this.liveid = liveid;
        this.native = native;
        this.init();
    }

    init() {
        var time = this.info.start_date;
        this.remainTime = Math.floor((new Date(time).valueOf() - new Date().valueOf()) / 1000);
        console.log(this.remainTime);
        if (this.remainTime <= 0) {
            return;
        }
    }

    checkAppoint() {
        let self = this;  
        return new Promise(function (resolve) {
            if (self.native.isApp) {
                return self.native.isTiming(self.liveid).then(function (ids) {
                    console.log('ids====' + ids);
                    if (ids.length == 0) {
                        //开启提醒标识
                        let el =  self.showAppoint();
                        resolve(el);
                    } else {
                        //取消提醒标识
                       let el = self.hideAppoint();
                        resolve(el);
                    }
                })
            }
        })
    }

    //开启提醒
    showAppoint() {
        let el = tmpl({
            hasApp: true,
            starttime : formatDate(this.info.start_date)
        });

        return el
    }

    //取消提醒
    hideAppoint() {
        let el = tmpl({
            hasApp: false,
            starttime : formatDate(this.info.start_date)
        });

        return el;
    }


    initEvent() {
        var self = this;
        var timeStamp = this.info.start_date;
        var type = this.info.from == 'h5' ? 'h5_live' : 'text_live';

        this.appEle = this.el.querySelector('.appbtn');

        this.appEle.addEventListener('touchend', function () {
            if(this.classList.contains('showApp')){
                console.log('1111');
                this.classList.remove('showApp');
                this.classList.add('hideApp');
                this.querySelector('.text').textContent = '取消提醒';
                self.native.setAlarmClock(self.info.liveid, timeStamp, self.info.title, type);
                if(self.info.hasPage) {//有图文直播
                    self.native.actionStat({type: "lorder", id: "piclive_" + self.info.liveid});//发送统计
                }else {
                    self.native.actionStat({type: "lorder", id: "vlive_" + self.info.liveid});//发送统计
                }
            }else {
                this.classList.remove('hideApp');
                this.classList.add('showApp');
                this.querySelector('.text').textContent = '开启提醒';
                self.native.cancelAlarmClock(self.info.liveid);
                if(self.info.hasPage) {//有图文直播
                    self.native.actionStat({type: "lunorder", id: "piclive_" + self.info.liveid});//发送统计
                }else {
                    self.native.actionStat({type: "lunorder", id: "vlive_" + self.info.liveid});//发送统计
                }

                console.log('22222');
            }
        });

        //时间到后自动隐藏当前dom
        let hideDom = setTimeout(function () {
            $(self.el).hide();
            clearTimeout(hideDom);
        }, this.remainTime * 1000);


    }

    renderTo(parentNode) {
        let self = this;
        this.checkAppoint().then(function (el) {

            parentNode.appendChild($(el)[0]);
            self.el = parentNode;
            self.initEvent();
        })

    }
}

let formatDate = (datestr)=> {

    let date = new Date(datestr);
    let month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    let min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();

    return month + '月' + day + '日' + hour + ':' + min;

};

export  default Notice


// WEBPACK FOOTER //
// ./app/modules/notice/index.js